import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UnitConstants } from 'src/app/core/constants/unit';
import { Unit } from 'src/app/core/interfaces/unit';
import { UnitsService } from 'src/app/core/services/units/units.service';

@Component({
  selector: 'app-unities-dropdown',
  templateUrl: './unities-dropdown.component.html',
  styleUrls: ['./unities-dropdown.component.scss'],
})
export class UnitiesDropdownComponent implements OnChanges {
  @Input() quantity = 'LENGTH';
  @Input() show = false;
  @Input() formName: string;
  @Input() id: string;

  @Output() selected = new EventEmitter<Unit>();

  units: Unit[];
  private _selectedUnit: string;

  constructor(private unitsService: UnitsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.quantity) {
      this.setUnitsArray();
      this.setFieldUnit();
    }
  }

  setUnitsArray(): void {
    if (UnitConstants[this.quantity]) {
      this.units = Object.entries(UnitConstants[this.quantity]).map(([reference, value]: any) => {
        return { reference, value: value.UNIT };
      });
    }
  }

  setFieldUnit(): void {
    const unit = this.unitsService.getFieldUnit(this.formName, this.id, this.quantity);
    this.selectUnit(unit);
  }

  selectUnit(unit: Unit): void {
    this.selectedUnit = unit.value;
    this.selected.emit(unit);
  }

  get selectedUnit(): string {
    return (
      this.unitsService.getFieldUnit(this.formName, this.id, this.quantity)?.value ||
      this._selectedUnit
    );
  }

  set selectedUnit(unit: string) {
    this._selectedUnit = unit;
  }
}
